import sounds from 'src/lib/sounds';
import { FlexBoxView } from '@play-co/timestep-core/flexbox';
import LeaderboardsTab from './LeaderboardsTab';

interface LeaderboardsTabConfig {
  label: string;
  onClick: () => Promise<void> | void;
  tracking: { feature: string; $subFeature: string };
}

export interface LeaderboardsNavConfig {
  tabs: LeaderboardsTabConfig[];
  selectedIndex?: number;
}

export default class LeaderboardsNav extends FlexBoxView {
  public readonly tabs: LeaderboardsTab[] = [];
  public disabled: boolean = false;

  public setup(opts: LeaderboardsNavConfig) {
    this.removeAllSubviews();

    this.updateOpts({
      flex: {
        justifyContent: 'space-around',
        alignItems: 'center',
        paddingLeft: 10,
        paddingRight: 10,
      },
    });

    opts.tabs.forEach((data, index) => {
      const tab = new LeaderboardsTab({
        superview: this,
        tracking: data.tracking,
        width: 224,
        height: 72,
        onClick: async () => {
          sounds.sfx.play('ok');
          this.updateSelected(index);
          return data.onClick();
        },
      });

      this.tabs.push(tab);
      tab.label = data.label;
      tab.tracking = data.tracking;
    });

    // Select active tab.
    const selected = opts.selectedIndex ?? 0;
    this.updateSelected(selected);
    void opts.tabs[selected].onClick();
  }

  public updateSelected(index: number) {
    if (this.disabled) {
      return;
    }

    // Clamp the index between 0 and tabs.length - 1
    const clampedIndex = Math.max(0, Math.min(index, this.tabs.length - 1));

    this.tabs.forEach((tab, i) => {
      tab.active = i === clampedIndex;
      tab.updateOpts({ blockEvents: tab.active });
    });
  }
}
